import { DataLayer } from '@grandvisionhq/analytics';

const CHANGE_SOLUTION_VOLUME_OR_VARIANT = 'click_solution_pdp';
var EventAction;
(function(EventAction) {
    EventAction["SelectVolume"] = 'select solutions volume';
    EventAction["QuantityIncrease"] = 'solutions quantity increase';
    EventAction["QuantityDecrease"] = 'solutions quantity decrease';
})(EventAction || (EventAction = {}));
const triggerDataLayerEvent = (eventAction, eventLabel)=>{
    DataLayer.pushEvent({
        event: CHANGE_SOLUTION_VOLUME_OR_VARIANT,
        eventAction,
        eventLabel
    });
};

export { EventAction, triggerDataLayerEvent };
//# sourceMappingURL=data-layer-utils.js.map
